/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Spicy_Mouse_HackInputs */

const fr_free_spicy_mouse_hack = /** @type {(inputs: Free_Spicy_Mouse_HackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afin d'accepter le cours, merci de sélectionner les utilisateur qui seront inscrits dessus`)
};

/**

* @param {Free_Spicy_Mouse_HackInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const free_spicy_mouse_hack = /** @type {((inputs?: Free_Spicy_Mouse_HackInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Spicy_Mouse_HackInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_free_spicy_mouse_hack(inputs)
});